import { render, staticRenderFns } from "./ConsentPad.vue?vue&type=template&id=341a9036"
import script from "./ConsentPad.vue?vue&type=script&lang=js"
export * from "./ConsentPad.vue?vue&type=script&lang=js"
import style0 from "./ConsentPad.vue?vue&type=style&index=0&id=341a9036&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports